import React, { useState, useEffect } from "react";
import {
  Paper,
  Divider,
  List,
  ListItem,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Link,
  Button,
  Badge,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import "./style.scss";

const references = (data) => (
  <Paper className="references">
    <h3>References</h3>
    <div>No specific reference is needed. The following are recommended:</div>
    <List className="list">
      {(data.items || []).map((el) => (
        <ListItem key={el.text}>
          <i className="bullet far fa-check-circle fa-xs" />
          <a href={el.link} target="_blank" rel="noopener noreferrer">
            {el.text}
          </a>
        </ListItem>
      ))}
    </List>
  </Paper>
);

const tools = (data) => (
  <Paper className="tools">
    <h3>Tools & Platforms</h3>
    <List className="list">
      {(data.items || []).map((el) => (
        <ListItem key={el.text}>
          {el.link && (
            <>
              <i className="bullet far fa-check-circle fa-xs" />
              <a href={el.link} target="_blank" rel="noopener noreferrer">
                {el.text}
              </a>
            </>
          )}
          {!el.link && (
            <>
              <i className="bullet far fa-check-circle fa-xs" />
              <div>{el.text}</div>
            </>
          )}
        </ListItem>
      ))}
    </List>
  </Paper>
);

const schedule = (data, activeWeek, superActiveWeek) => (
  <div className="schedule">
    <TableContainer className="table-container">
      <Table stickyHeader aria-label="sticky table">
        <caption>A basic table example with a caption</caption>
        <TableHead>
          <TableRow>
            {data.columns.map((column) => (
              <TableCell
                key={column.id}
                align={"center"}
                style={{ minWidth: column.minWidth }}
              >
                {column.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.rows.map((row) => {
            if (row.divider) {
              return (
                <TableRow key={row.title}>
                  <TableCell colSpan={data.n}>
                    <h3>{row.title}</h3>
                  </TableCell>
                </TableRow>
              );
            }
            return (
              <TableRow hover role="checkbox" tabIndex={-1} key={row.week}>
                {data.columns.map((column, idx) => {
                  const value = row[column.id];
                  return (
                    <TableCell key={column.id} align={column.align}>
                      {Array.isArray(value) && (
                        <List>
                          {(value || []).map((d) => {
                            const text = d[0];
                            const link = d[1];
                            if (!text) {
                              return null;
                            }
                            return (
                              <ListItem key={text}>
                                {link && (
                                  <Link
                                    href={link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {text}
                                  </Link>
                                )}
                                {!link && <bdi>{text}</bdi>}
                              </ListItem>
                            );
                          })}
                        </List>
                      )}
                      {!Array.isArray(value) && idx === 0 && (
                        <Badge
                          className="doneWeeks"
                          badgeContent={value}
                          color="secondary"
                        >
                          <Typography>
                            <i className="fas fa-cannabis fa-lg" style={{color: '#d54700'}} />
                          </Typography>
                        </Badge>
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  </div>
);

const offerings = (data) => (
  <div className="offerings">
    <h3>Previous Offerings</h3>
    {data.map((item) => (
      <Link key={item[0]} href={item[1]}>
        <Button variant="outlined">{item[0]}</Button>
      </Link>
    ))}
  </div>
);

export default function MainBody() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      const res = await fetch("./assets/data/data.json");
      const data = await res.json();
      setData(data);
    };
    fetchData();
  }, []);

  // const startDate = moment("2020-02-08");
  // const nowDate = moment();
  // const endDate = moment("2020-06-06");
  // const totalDays = endDate.diff(startDate, "days");
  // const nowToEndDays = endDate.diff(nowDate, "days");
  // let activeWeek = parseInt((totalDays - nowToEndDays) / 7, 10) + 1;
  // activeWeek = activeWeek > 15 ? -1 : activeWeek;
  // const superActiveWeek = activeWeek - 4;

  if (!data) {
    return <div></div>;
  }
  return (
    <div className="main-body">
      {references(data.references)}
      {tools(data.tools)}
      {schedule(data.schedule)}
      <Divider />
      <Divider />
      <Divider />
      {offerings(data.offerings)}
    </div>
  );
}
